// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__29rPc","inputWrap":"Table_inputWrap__3iB5m","col":"Table_col__6xIBh","bmiTooltip":"Table_bmiTooltip__2syP4"};